// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i3yOzyryEN {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.i3yOzyryEN h4 {
  line-height: 3em;
}
.i3yOzyryEN ._gdktZNLcm {
  float: left;
  width: 100%;
}
.i3yOzyryEN .tXHsbG4Wtw {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.i3yOzyryEN .tXHsbG4Wtw:hover {
  cursor: pointer;
}
.i3yOzyryEN .tXHsbG4Wtw:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.tEeM135B93 .ghTC5k1wTg:focus {
  outline: none;
}
.tEeM135B93 .ghTC5k1wTg.lCmA9XvETo.zWYIXN03g4 {
  background: #375A88;
}
.tEeM135B93 .ghTC5k1wTg.lCmA9XvETo.zWYIXN03g4 span {
  color: #fff;
}
.tEeM135B93 .zWYIXN03g4 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.tEeM135B93 .zWYIXN03g4:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.tEeM135B93 input {
  height: 38px;
  min-width: 220px;
}
.tXHsbG4Wtw.l_wy4WTLpC {
  background: #410102;
}
.tXHsbG4Wtw.cV9_B80yHA {
  background: #911318;
}
.tXHsbG4Wtw.uTeHHRRjfg {
  background: #D8293B;
}
.tXHsbG4Wtw.NS2sKZTKtF {
  background: #F2373C;
}
.tXHsbG4Wtw.RTi7sCOUO3 {
  background: #FC4448;
}
.tXHsbG4Wtw.WRsItTdB45 {
  background: #ED535E;
}
.tXHsbG4Wtw.zz7m6ta1lg {
  background: #E34926;
}
.tXHsbG4Wtw.Z3G_y7Zbca {
  background: #FC562B;
}
.tXHsbG4Wtw.MqDGc2ohu0 {
  background: #FC6722;
}
.tXHsbG4Wtw.dtQFl3T1Ti {
  background: #FD7F24;
}
.tXHsbG4Wtw.HLZBTcJ7QC {
  background: #FD8D26;
}
.tXHsbG4Wtw.uNBgKnBHE2 {
  background: #EC9C3E;
}
.tXHsbG4Wtw.rmSENTTqrL {
  background: #0e673a;
}
.tXHsbG4Wtw.FNFBKkfiNW {
  background: #208740;
}
.tXHsbG4Wtw.AfAJ8ulAEx {
  background: #239718;
}
.tXHsbG4Wtw.gvpoyNBovj {
  background: #55A84D;
}
.tXHsbG4Wtw.Gkp53jjwUo {
  background: #4BBE5A;
}
.tXHsbG4Wtw.x_YQXQcroY {
  background: #0CCA6A;
}
.tXHsbG4Wtw.dhdCxRP_8x {
  background: #0A3C64;
}
.tXHsbG4Wtw.fbogGKcOfz {
  background: #0d487a;
}
.tXHsbG4Wtw.MNrt4aic4t {
  background: #10538d;
}
.tXHsbG4Wtw.YZYIiLsVpv {
  background: #115A99;
}
.tXHsbG4Wtw.RP8zYF6eTZ {
  background: #3387E2;
}
.tXHsbG4Wtw.EAwZdeOcaj {
  background: #1BA9CF;
}
.tXHsbG4Wtw.Hzq99tDgzl {
  background: #d27c02;
}
.tXHsbG4Wtw.hXdjb3sPGm {
  background: #fb9402;
}
.tXHsbG4Wtw.EYk4_9OG9D {
  background: #FD9B30;
}
.tXHsbG4Wtw.Ld5QEkDr5w {
  background: #FDBE2D;
}
.tXHsbG4Wtw.Bsca4oydH0 {
  background: #FED831;
}
.tXHsbG4Wtw.obJ5BusWjq {
  background: #FFFD38;
}
.tXHsbG4Wtw.mFG9f0_HdJ {
  background: #2D215C;
}
.tXHsbG4Wtw.uHxsSvkOEb {
  background: #483C83;
}
.tXHsbG4Wtw.Vq58Lc3Owx {
  background: #58518d;
}
.tXHsbG4Wtw.vm4T9gx9TW {
  background: #7068A9;
}
.tXHsbG4Wtw.QjpepZ6AQg {
  background: #7f78b2;
}
.tXHsbG4Wtw.HJYjIBOB7R {
  background: #8f88bc;
}
.tXHsbG4Wtw.wNSZyvP1Gb {
  background: #000;
}
.tXHsbG4Wtw.Q8pnIvZoC5 {
  background: #282626;
}
.tXHsbG4Wtw.kALivrKoVG {
  background: #242222;
}
.tXHsbG4Wtw.Gszepg7VpU {
  background: #353838;
}
.tXHsbG4Wtw.gX6C0iWMb5 {
  background: #666;
}
.tXHsbG4Wtw.z9oYKGHCDE {
  background: #999;
}
.Wpnz6Wiq4B {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.Wpnz6Wiq4B .JIjgqEXegz {
  display: none;
}
.ASvynZAJGN {
  display: flex;
  align-items: baseline;
  font-size: 13px;
  margin-bottom: 12px;
}
.ASvynZAJGN .GtARXiYSjS {
  font-size: 13px;
  margin-bottom: 0;
  margin-right: 8px;
}
.ASvynZAJGN > i {
  font-size: 15px;
  margin-right: 8px;
}
.aGotgNTSJz.aGotgNTSJz {
  padding: 12px 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `i3yOzyryEN`,
	"color-row": `_gdktZNLcm`,
	"color-tile": `tXHsbG4Wtw`,
	"picker-component": `tEeM135B93`,
	"picker-element": `ghTC5k1wTg`,
	"active": `lCmA9XvETo`,
	"btn": `zWYIXN03g4`,
	"red-1": `l_wy4WTLpC`,
	"red-2": `cV9_B80yHA`,
	"red-3": `uTeHHRRjfg`,
	"red-4": `NS2sKZTKtF`,
	"red-5": `RTi7sCOUO3`,
	"red-6": `WRsItTdB45`,
	"orange-1": `zz7m6ta1lg`,
	"orange-2": `Z3G_y7Zbca`,
	"orange-3": `MqDGc2ohu0`,
	"orange-4": `dtQFl3T1Ti`,
	"orange-5": `HLZBTcJ7QC`,
	"orange-6": `uNBgKnBHE2`,
	"green-1": `rmSENTTqrL`,
	"green-2": `FNFBKkfiNW`,
	"green-3": `AfAJ8ulAEx`,
	"green-4": `gvpoyNBovj`,
	"green-5": `Gkp53jjwUo`,
	"green-6": `x_YQXQcroY`,
	"blue-1": `dhdCxRP_8x`,
	"blue-2": `fbogGKcOfz`,
	"blue-3": `MNrt4aic4t`,
	"blue-4": `YZYIiLsVpv`,
	"blue-5": `RP8zYF6eTZ`,
	"blue-6": `EAwZdeOcaj`,
	"yellow-1": `Hzq99tDgzl`,
	"yellow-2": `hXdjb3sPGm`,
	"yellow-3": `EYk4_9OG9D`,
	"yellow-4": `Ld5QEkDr5w`,
	"yellow-5": `Bsca4oydH0`,
	"yellow-6": `obJ5BusWjq`,
	"purple-1": `mFG9f0_HdJ`,
	"purple-2": `uHxsSvkOEb`,
	"purple-3": `Vq58Lc3Owx`,
	"purple-4": `vm4T9gx9TW`,
	"purple-5": `QjpepZ6AQg`,
	"purple-6": `HJYjIBOB7R`,
	"black-1": `wNSZyvP1Gb`,
	"black-2": `Q8pnIvZoC5`,
	"black-3": `kALivrKoVG`,
	"black-4": `Gszepg7VpU`,
	"black-5": `gX6C0iWMb5`,
	"black-6": `z9oYKGHCDE`,
	"picker-theme": `Wpnz6Wiq4B`,
	"arrow-regular": `JIjgqEXegz`,
	"review-detail__field": `ASvynZAJGN`,
	"review-field__label": `GtARXiYSjS`,
	"tab-root__header": `aGotgNTSJz`
};
export default ___CSS_LOADER_EXPORT___;
